module.exports = __webpack_public_path__ + "static/media/vivi-repousando-direita.3af799ba.svg";